import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Route, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { UserAccessService } from '../services/user-access.service';
import { environment } from 'environments/environment';
import { Observable } from '../../../../node_modules/rxjs';

@Injectable()
export class SecurableGuard implements CanActivate {

	constructor(
		private router: Router,
		private aSvc: UserAccessService
	) {

	}
	/**
	 * Checks if the logged in user can access the route they're trying to and either lets them 
	 * pass or redirects them to their unauthorized location.
	 * @param route The route snapshot
	 * @param state The current router state
	 * @return a promise for the completion that resolves returning a boolean
	 */
	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
		return this.aSvc.canAccess(this.aSvc.getBaseRouteOfURL(state.url)).toPromise()
		.then(rsp => {
			if (rsp === true) {
				return rsp;
			}
			// User unauthorized to load this component force them back to their homepage
			this.aSvc.UnauthorizedRedirect();
			return false;
		})
		.catch(error => false);
	}
}
